import type { ApiResponse } from './estClient';

import { estClient } from './estClient';

class IntegrationApi {
  readonly CODE = {
    BINOTEL: 'binotel',
    PHONET: 'phonet',
    RINGOSTAT: 'ringostat',
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    GOOGLE_ADS: 'google_ads',
    PIPEDRIVE: 'pipedrive',
    NETSUITE: 'netsuite',
    GOOGLE_SHEETS: 'google_sheets',
    GOOGLE_DATA_STUDIO: 'google_data_studio',
    POWER_BI: 'power_bi',
    FORMCARRY: 'formcarry',
    FORMKEEP: 'formkeep',
    WEPSTER: 'wepster',
    EASYBUSY: 'easybusy',
    TELEGRAM: 'telegram',
    GLIDE: 'glide',
  } as const;

  async getStatuses(): Promise<IntegrationStatus[]> {
    const resp = await estClient.get<IntegrationStatusesResponse>(
      '/api/integration/status',
    );

    return resp.integrations;
  }
}

export const integrationApi = new IntegrationApi();

export type IntegrationCode =
  (typeof integrationApi.CODE)[keyof typeof integrationApi.CODE];

export interface IntegrationStatus {
  code: IntegrationCode;
  is_connected: boolean;
  /**
   * Whether there is a settings page to open once connected
   */
  has_settings: boolean;
  /**
   * Shown on the integration card - only the filled in fields, empty while not connected
   */
  details: Partial<Record<IntegrationDetailKey, string | number>>;
}

export type IntegrationDetailKey =
  | 'project_id'
  | 'business_id'
  | 'bot_name'
  | 'webhook_created_at'
  | 'connected_by_email'
  | 'installed_at'
  | 'domain'
  | 'synced_at'
  | 'webhook_received_at'
  | 'providers_count'
  | 'accounts_count'
  | 'providers_synced_at'
  | 'users_enabled_count'
  | 'users_total_count'
  | 'users_connected_at';

type IntegrationStatusesResponse = ApiResponse<{
  integrations: IntegrationStatus[];
}>;
